import { DatePipe } from '@angular/common';
import { Component, computed, inject, resource } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SimpleApi } from '@core/api/simple.api';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { RolleDatasource } from '@features/roller/rolle.datasource';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { Konvertering } from '../konvertering.model';

@Component({
  selector: 'app-konvertering-grid',
  imports: [
    TableModule,
    DatePipe,
    RouterLink,
    TableRowDirective,
    ButtonModule,
    ToolbarModule,
    FormsModule,
  ],
  templateUrl: './konvertering-grid.component.html',
  styleUrl: './konvertering-grid.component.css',
})
export class KonverteringGridComponent {
  simpleApi = inject(SimpleApi);
  rolleDatasource = inject(RolleDatasource);
  roller = computed(() => {
    const apiResponse = this.rolleDatasource.data.value();
    if (apiResponse) {
      return apiResponse.data;
    }
    return [];
  });

  konverteringer = resource({
    loader: async ({ abortSignal }) => {
      return await this.simpleApi.getList<Konvertering>(
        `/api/admin/konvertering`,
        {},
        abortSignal
      );
    },
  });
}
